import * as React from 'react'

interface Props<T> {
  batchSize: number
  items: T[]
}
interface Pagination<T> {
  paginatedItems: T[]
  loadMore: (page: number) => void
  hasMore: boolean
  page: number
}

function usePagination<T>({ batchSize, items }: Props<T>): Pagination<T> {
  const [page, setPage] = React.useState(1)
  const [hasMore, setHasMore] = React.useState(items.length > batchSize)

  const loadMore = (newPage: number) => {
    setPage(newPage)
    setHasMore(items.length > batchSize * newPage)
  }

  React.useEffect(() => {
    loadMore(page)
  }, [items]) // eslint-disable-line react-hooks/exhaustive-deps

  const paginatedItems = items.slice(0, batchSize * page)

  return {
    paginatedItems,
    loadMore,
    hasMore,
    page,
  }
}

export default usePagination
